import ContentPanel from './ContentPanel';
import { Icon, Icons } from '@platform/components';
import { H2 } from './utils';
import FeatureItem from './FeatureItem';

const HorizontalFeatureSection = ({
  header,
  description,
  items,
}: {
  header: string;
  description?: string;
  items: { icon: keyof typeof Icons; title: string; subtitle: string }[];
}) => {
  return (
    <ContentPanel>
      {/* Extra div to center because this is the only h2 in this page that is centered */}
      <div className='text-center'>
        <H2>{header}</H2>
        {description && <div className='mt-4 sm:mt-5 text-gray-500 text-xl'>{description}</div>}
        <div className='mt-12 sm:mt-16 flex flex-col sm:flex-row gap-10 sm:gap-8'>
          {items.map((item) => (
            <FeatureItem
              key={item.icon}
              iconContent={<Icon type={item.icon} size='24' />}
              title={item.title}
              description={item.subtitle}
            />
          ))}
        </div>
      </div>
    </ContentPanel>
  );
};

export default HorizontalFeatureSection;
